import { render, staticRenderFns } from "./CForm.vue?vue&type=template&id=bca355f6&"
import script from "./CForm.vue?vue&type=script&lang=js&"
export * from "./CForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports